var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5938 11.4314C19.1961 11.4314 20.4959 10.1325 20.4959 8.53016C20.4959 6.92782 19.1961 5.62891 17.5938 5.62891",
    stroke: "#68768B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9297 14.585C19.4082 14.618 19.8839 14.6858 20.3524 14.7912C21.0032 14.9186 21.786 15.1854 22.0647 15.7693C22.2425 16.1433 22.2425 16.5787 22.0647 16.9536C21.7869 17.5375 21.0032 17.8034 20.3524 17.9372",
    stroke: "#68768B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28889 11.4314C4.68655 11.4314 3.38672 10.1325 3.38672 8.53016C3.38672 6.92782 4.68655 5.62891 6.28889 5.62891",
    stroke: "#68768B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95565 14.585C4.47715 14.618 4.0014 14.6858 3.53298 14.7912C2.88215 14.9186 2.09931 15.1854 1.82156 15.7693C1.64281 16.1433 1.64281 16.5787 1.82156 16.9536C2.0984 17.5375 2.88215 17.8034 3.53298 17.9372",
    stroke: "#68768B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9386 15.21C15.1855 15.21 17.9593 15.7013 17.9593 17.6675C17.9593 19.6329 15.2038 20.1425 11.9386 20.1425C8.69089 20.1425 5.91797 19.6512 5.91797 17.685C5.91797 15.7187 8.67347 15.21 11.9386 15.21Z",
    stroke: "#68768B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9364 12.4049C9.79504 12.4049 8.07812 10.688 8.07812 8.54575C8.07812 6.40442 9.79504 4.6875 11.9364 4.6875C14.0777 4.6875 15.7946 6.40442 15.7946 8.54575C15.7946 10.688 14.0777 12.4049 11.9364 12.4049Z",
    stroke: "#68768B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.92224d0fdc09fabbc12da86cd3c6dbc9.svg";
export { ForwardRef as ReactComponent };